import { render, staticRenderFns } from "./jxs.vue?vue&type=template&id=1bcc4376&scoped=true&"
import script from "./jxs.vue?vue&type=script&lang=js&"
export * from "./jxs.vue?vue&type=script&lang=js&"
import style0 from "./jxs.vue?vue&type=style&index=0&id=1bcc4376&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc4376",
  null
  
)

export default component.exports